import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalComponent } from '../../../modals/modal/modal.component';

@Component({
  selector: 'app-edit-level-names-modal',
  standalone: false,
  templateUrl: './edit-level-names-modal.component.html',
  styleUrl: './edit-level-names-modal.component.scss',
})
export class EditLevelNamesModalComponent implements OnInit, OnChanges {
  @ViewChild('modal')
  modal: ModalComponent;

  @Input() levelNames: string[];

  @Output() readonly levelsUpdated = new EventEmitter<string[]>();

  levelForm: FormGroup;

  isUpdating = true;

  levelFormSubmitted = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createFromControls();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['levelNames'] &&
      changes['levelNames'].currentValue !==
        changes['levelNames'].previousValue &&
      changes['levelNames'].firstChange === false
    ) {
      this.isUpdating = true;
      this.resetForm();
      this.createFromControls();
    }
  }

  get f() {
    return this.levelForm.controls;
  }

  createFromControls() {
    if (this.levelNames) {
      this.levelForm = this.formBuilder.group({});
      for (let i = 1; i <= this.levelNames.length; i += 1) {
        this.levelForm.addControl(
          `level${i}`,
          new FormControl(this.levelNames[i - 1], Validators.required)
        );
      }
      this.isUpdating = false;
    }
  }

  removeAllFormGroupControls() {
    Object.keys(this.levelForm.controls).forEach((key) => {
      this.levelForm.removeControl(key);
    });
  }

  resetForm() {
    this.removeAllFormGroupControls();
    this.levelFormSubmitted = false;
    this.isUpdating = false;
  }

  closeModal() {
    this.resetForm();
    this.createFromControls();
    this.modal.close();
  }

  onSubmit() {
    this.levelFormSubmitted = true;

    if (this.levelForm.invalid) {
      return;
    }

    if (this.levelForm.pristine) {
      this.closeModal();
      return;
    }

    this.isUpdating = true;

    const updatedLevels: string[] = [];
    for (let i = 1; i <= this.levelNames.length; i += 1) {
      updatedLevels.push(this.f[`level${i}`].value);
    }

    this.levelsUpdated.emit(updatedLevels);
    setTimeout(() => {
      this.closeModal();
    }, 400);
  }
}
